import React, { useState} from 'react'
import {Grid, useMediaQuery, Container } from '@mui/material';
import swal from "sweetalert";
import config from '../../../AppConfig';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};



function EventsocialMediaLinks(props) {
    const isMobile = useMediaQuery('(max-width:600px)');

    return (
        <>
            <Container maxWidth="lg">
                <Grid Container item lg={12} md={12} sm={12} xs={12} sx={{display:"flex",justifyContent:"center",alignItems:'flex-end',marginTop:isMobile?"4%":"1%"}}>
                    <Grid item sx={{marginTop:"4%"}}>
                        <img src={config.BACKEND_URL + "images/mfsnlogo1.png"} style={{width: isMobile ? "40vw":"25vw"}} />
                    </Grid> 
                </Grid>

                <Grid Container item lg={12} md={12} sm={12} xs={12} sx={{textAlign:"center",marginTop:"4%"}} >
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{
                                backgroundImage: 'url("https://api.myfreescorenow.com/public/images/firstbar.png")',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '100% 75%',
                                backgroundPosition: 'center',
                                height: isMobile ? '250px' : '100px',
                                // minWidth: isMobile ? 'auto' : '1025px',
                                minWidth: 'auto',
                                display: 'flex',
                                alignItems: 'center', // vertical center
                                justifyContent: 'center', // horizontal center
                                textAlign: 'center',
                            }}
                            >
                        
                            <a href="https://app.gohighlevel.com/v2/preview/PXdUAfTlWQ6JXO05BwVy?notrack=true"><span style={{fontSize:'large', color:'white',fontWeight:'600', textDecoration: "none"}}>SCHEDULE YOUR PODCAST</span></a>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{textAlign:"center",marginTop:"4%"}}>
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{
                                backgroundImage: 'url("https://api.myfreescorenow.com/public/images/secondbar.png")',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '100% 75%',
                                backgroundPosition: 'center',
                                height: isMobile ? '250px' : '100px',
                                // minWidth: isMobile ? 'auto' : '1025px',
                                minWidth: 'auto',
                                display: 'flex',
                                alignItems: 'center', // vertical center
                                justifyContent: 'center', // horizontal center
                                textAlign: 'center',
                            }}
                            >
                        <a href="//www.facebook.com/share/g/15A4azgugH/"><span style={{fontSize:'large', color:'white',fontWeight:'600', textDecoration: "none"}}>JOIN FACEBOOK COMMUNITY</span></a>
                    </Grid>
                    </Grid> 
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{textAlign:"center",marginTop:"4%"}} >
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{
                                backgroundImage: 'url("https://api.myfreescorenow.com/public/images/thirdbar.png")',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '100% 75%',
                                backgroundPosition: 'center',
                                height: isMobile ? '250px' : '100px',
                                // minWidth: isMobile ? 'auto' : '1025px',
                                minWidth: 'auto',
                                display: 'flex',
                                alignItems: 'center', // vertical center
                                justifyContent: 'center', // horizontal center
                                textAlign: 'center',
                            }}
                            >
                        {/* <span style={{color:'white',fontWeight:'600'}}>SUBSCRIBE ON YOUTUBE</span> */}
                        <a href="https://www.youtube.com/@MyFreeScoreNow"><span style={{fontSize:'large', color:'white',fontWeight:'600', textDecoration: "none"}}>SUBSCRIBE ON YOUTUBE</span></a>
                    </Grid>
                    </Grid> 
                </Grid>

            </Container>
           
        </>
    )
    }

export default EventsocialMediaLinks;